import { combineReducers } from "redux";
import { routerReducer as router } from "react-router-redux";
import subscription from "../components/LandingContainer/reducers";
import quote from "../components/checkout/MainForm/reducers";
import subscriptionStatus from "./subscriptionStatus/reducers";
import auth from "../components/App/reducers";
import { states, countries } from "../utils/constants";
import userSubscriptionDetails from "./subscriptionDetails/reducers";
import freeTrial from "./freeTrial/reducers";
import termsDlg from "./termsDlg/reducers";

export default combineReducers({
  auth,
  router,
  subscription,
  subscriptionStatus,
  quote,
  paths: (state = {}) => state,
  stripeApiKey: (state = "") => state,
  amplitude: (state = "") => state,
  constants: () => ({ states, countries }),
  productInfo: (state = {}) => state,
  userDetails: (state = {}) => state,
  userSubscriptionDetails,
  freeTrial,
  termsDlg,
});
